import React, { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import FsLightbox from "fslightbox-react";
import { Banner } from "../../components/Banner/Banner";
import {
  bloginnerban,
  facebook,
  gallery1,
  leftarrow,
  mainimg,
  moreblog1,
  moreblog2,
  moreblog3,
  coloredArrow,
  playicon,
  whatsapp,
  linkedinblog,
  twitterblog,
  copy,
  mainimgmob,
  bannerInner,
} from "../../images";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { Link, NavLink } from "react-router-dom";
//utils
import { reduceDescSize } from "../../helpers/utils";

import "./BlogInner.scss";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const BlogInner = () => {
  const { width } = useWindowDimensions();
  const [copied, setCopied] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [vidLink, setVidLink] = useState("");

  const blogDateArr = [
    {
      date: "June 2, 2022",
      category: "Lorem Ipsum",
      company: "Sanathan",
    },
  ];

  const blogDescArr = [
    {
      id: 1,
      heading: "Recycled Pet Chips 101: Explained",
      desc1:
        "Polyester is one of the world’s most popular textiles and it is used in thousands of different consumer and industrial applications. Worldwide, more than 22.67 billion tonnes of polyester clothes are produced each year.<br /><br /><strong>But, What Is Polyester?</strong><br />Polyester is the most common form of Polyethylene Terephthalate (PET) and highly recyclable plastic material. It's a polymer made up of two monomers: mono ethylene glycol and purified terephthalic acid. <br /><br />It is a man-made, synthetic fibre derived from a chemical reaction between petroleum, air and water. As a result, it is not biodegradable and will remain in a landfill for years unless recycled. When polyester is laundered, it also sheds microplastic strands, which end up in our streams, oceans, and eventually our food chains after being devoured by fish and other aquatic organisms. Considering this, the production of virgin polyester is exceedingly unsustainable.<br />So, what is the best alternative to Virgin Polyester? Well, it is Recycled Polyester!<br /><br /><strong>What Is Recycled Polyester And How Is It Made?</strong><br />Often called RPET with the “R” standing for recycled and the ”PET” for polyethene terephthalate. Recycled polyester is a favoured alternative to virgin polyester and is made mostly from plastic bottles, packaging, textile waste or fishnets retrieved from the ocean. The steps involved in the production process are:<br /><ul><li>1.	The PET bottles that have been collected are sanitised, dried, and crushed into small fragments.</li><br /><li>2.	The chips are heated and spun into yarn threads using a spinneret.</li><br /><li>3.	This yard is made up of spools.</li><br /><li>4.	The fibre is then crimped to create a fluffy woolly texture.</li><br /><li>5.	After that, the yarn is baled, coloured, and woven into polyester fabric.</li></ul><br /><strong>Is Recycled Polyester Clothing Eco-Friendly Over Virgin Polyester?</strong><br />Polyester accounts for more than half of the fibres used in the textile and garment industries; replacing it with a recycled substitute will immediately reduce reliance on fossil fuels, will consume less energy, and emit fewer carbon emissions. Waste is diverted from the oceans and landfills by making RPET from plastic bottles, fishing nets, and textile waste. Hence, the creation of a popular non-virgin alternative will have a positive impact on future energy needs.<br />Recycled polyester fabric contributes to the reduction of seismic waste in the fashion industry, which disposes of approximately 48 million mt of clothing each year.<br /> Many studies have shown that textiles or garments created from recycled polyester can be recycled repeatedly without compromising the fibre's characteristics and attributes. If this is adopted at the industry level, polyester can be recycled and utilised for a considerably longer period, resulting in a closed-loop system — one of the most important aspects of implementing a sustainable manufacturing system.<br /><br /><strong>Global Benefits Of Using Recycled Over Virgin Polyester</strong><br />Recycling is motivated by environmental considerations. Environmentally, reused materials use waste and reduce the consumption of new raw materials. Recycled polyester has nearly the same qualities as virgin polyester, but with substantial environmental benefits. Moreover, there is NO difference to the end product and that’s why it is the best alternative to virgin polyester. It is long-lasting, lightweight, crease-resistant, colourfast, quick-drying and stain-resistant. This is why polyester is commonly used in all textiles, including home textiles, fashion, sports and outdoor clothes, etc.<br /><br />The reduction of bottles in landfills is a significant advantage of using recycled polyester versus virgin polyester. Plastic bottles are reused in the recycled polyester fibre production process, which has significant benefits for minimising contamination of the ground, as well as water and air pollution. This also means that less petroleum is utilised in the production of recycled polyester. When compared to virgin polyester, recycled polyester results in significant energy savings during the fibre production process. Choosing recycled polyester over virgin polyester results in a 20% reduction in water use and a 30% reduction in CO2 emissions.<br />At Sanathan Textiles, the recycled polyester yarn that we produce is through a technologically advanced and environmentally conscious manufacturing setup.<br /><br /><strong>About Sanathan Textiles</strong><br />Sanathan Textiles is a global supplier of Cotton Yarns, Polyester Yarns and Yarns for Technical Textiles. With 3 yarn business verticals, we offer a wide variety of yarns that are used by various sectors and industries, across applications and end-uses. Technologically advanced and environmentally conscious manufacturing setup enables us to offer customers value-added yarns, niche yarns, functional yarns and a wide range of coloured yarns. Sanathan Textiles is committed to providing Value added Innovative Yarns for the Fabric of our Lives.",
    },
  ];

  const moreblogsArr = [
    {
      img: moreblog1,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog3,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
  ];

  const galleryArr = [
    {
      id: 1,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 2,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 3,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 4,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
  ];

  useEffect(() => {
    var gallery_swiper_container = new Swiper(
      ".swiper-container.gallery_swiper_container",
      {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          prevEl: ".bloginner_sec2 .left_arrow",
          nextEl: ".bloginner_sec2 .right_arrow",
        },
        breakpoints: {
          767: {
            slidesPerView: 1.6,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 2.7,
            spaceBetween: 10,
          },
        },
        // loop: true,
        // centeredSlides: true,
        // loopedSlides: thumbArr.length, //how many slides it should duplicate
      }
    );
    var moreblogs_swiper_container = new Swiper(
      ".swiper-container.moreblogs_swiper_container",
      {
        slidesPerView: 3,
        spaceBetween: 40,
        loop: false,
        navigation: {
          prevEl: ".bloginner_sec3 .left_arrow",
          nextEl: ".bloginner_sec3 .right_arrow",
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          767: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      }
    );
  });

  useEffect(() => {
    if (copied) {
      let copiedTimeout = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => {
        clearTimeout(copiedTimeout);
      };
    }
  }, [copied]);

  const dateList = blogDateArr.map((item) => (
    <>
      <p className="blog_date">{item.date} | </p>
      <p className="blog_category"> {item.category} </p>
      <p className="blog_company">| {item.company}</p>
    </>
  ));

  const descList = blogDescArr.map((item) => (
    <>
      <p
        className="blog_desc"
        dangerouslySetInnerHTML={{ __html: item.desc1 }}
      />
    </>
  ));

  const galleryVideoImageList = galleryArr.length
    ? galleryArr.map((item, i) => (
        <div className="swiper-slide" key={i}>
          {item.type == "video" ? (
            <>
              <div
                className="video_wrapper_div"
                onClick={() => handleImageWrapperClick(item.ytLink)}
              >
                <div className="content">
                  <img
                    src={item.image}
                    alt="Sanathan video gallery img"
                    loading="lazy"
                    className="gallery_img"
                  />
                  <div className="content-overlay"></div>
                  <img
                    src={playicon}
                    alt="Sanathan coloredArrow img"
                    loading="lazy"
                    className="playicon"
                    onClick={() => handleImageWrapperClick(item.ytLink)}
                  />
                  {/* <h2 className="galleryImageName">{item.title}</h2> */}
                </div>

                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          ) : (
            <>
              <div className="content">
                <img
                  src={item.image}
                  alt="Sanathan blog gallery img"
                  loading="lazy"
                  className="gallery_img"
                />
                <div className="content-overlay"></div>
                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          )}
        </div>
      ))
    : null;

  const moreblogsList = moreblogsArr.map((item, i) => (
    <>
      <li className="swiper-slide moreblog_detail_wrapper">
        <Link to="/blog-inner" key={i}>
          <div className="imageanimate zoom-out">
            <img
              src={item.img}
              alt="Sanathan our blog img"
              loading="lazy"
              className="moreblog_img"
            />
            {/* <div className="content-overlay"></div> */}
          </div>
          <div className="text_container">
            <h1 className="moreblog_date">{item.date}</h1>
            <div className="verticle_line"> | </div>
            <h1 className="moreblog_category"> {item.category}</h1>
            <h1 className="moreblog_name">{item.title}</h1>
            <p className="moreblog_synopsis">
              {reduceDescSize(item.desc, 100)}
            </p>
            <div className="moreblog_cta_wrapper"></div>
          </div>
        </Link>
      </li>
    </>
  ));

  const handleImageWrapperClick = (videoLink) => {
    setToggler(!toggler);
    setVidLink(videoLink);
  };

  const copyUrl = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <MetaDecorator
        canonicalLink="https://www.sanathan.com/blogs/recycled-pet-chip"
        metaTitle="Recycled Pet Chips 101: Explained | Sanathan Textiles"
        metaDesc="Recycled polyester fabric contributes to the reduction of seismic waste in the fashion industry. Click here to learn more."
      />
      {/* <Banner
        imgSrc="https://via.placeholder.com/1920x300"
        breadcrumbWord1="Home"
        breadcrumbWord3="Blogs"
        breadcrumbWord4={blogDescArr[0].heading}
        link3="blogs"
        disabled
      /> */}
      <section className="bloginner_sec1" data-aos="fade-in">
        <div className="wrapper">
          {/* <div className="breadcrumb_styles">Home {">"} Blog Inner</div> */}
          {/* <div className="blog_heading">
            Blog Heading will come here lorem ipsum lorem ipsum example text
            here
          </div> */}
          <img
            className="mainimg"
            src={bannerInner}
            alt="Sanathan blog inner img"
          />
          <div className="row social_icon_date">
            <div className="col-md-6 col-lg-4 datecat_list">
              {/* {dateList} */}
            </div>
            <div className="col-md-1 col-lg-4"></div>
            <div className="col-md-5 col-lg-4">
              {width < 767 ? <h2 className="share_title">Share</h2> : null}
              <div className="social_main_wrapper">
                <ul className="social_icons">
                  {width > 767 ? (
                    <li className="social_icon_li">
                      <h2 className="share_title">Share</h2>
                    </li>
                  ) : null}
                  <li className="social_icon_li">
                    <FacebookShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={facebook}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </FacebookShareButton>
                  </li>
                  <li className="social_icon_li">
                    <WhatsappShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={whatsapp}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </WhatsappShareButton>
                  </li>
                  <li className="social_icon_li">
                    <TwitterShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={twitterblog}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </TwitterShareButton>
                  </li>
                  <li
                    className="social_icon_li social_icon_li_copy"
                    onClick={copyUrl}
                  >
                    <span className="social_icon">
                      <img
                        src={copy}
                        alt="Sanathan copy url logo"
                        loading="lazy"
                      />
                    </span>
                    <span className="social_name">
                      {!copied ? "" : "Copied!"}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="horizontal_line"></div>
          <h1 className="blog_inner_name">
            Recycled Pet Chips 101: Explained
          </h1>
          <div>{descList}</div>
        </div>
      </section>

      {/* {galleryVideoImageList && (
        <section className="bloginner_sec2" data-aos="fade-up">
          <div className="wrapper">
            <div className="heading_arrow_flex">
              <div className="gallery_heading">Gallery</div>
              {width > 767 ? (
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              ) : null}
            </div>
            <div className="gallery_slider_wrapper">
              <div className="swiper-container gallery_swiper_container">
                <div className="swiper-wrapper">{galleryVideoImageList}</div>
              </div>
              {width < 767 ? (
                <div className="arrows_wrapper">
                  <div className="navigations">
                    <button className="left_arrow">Previous</button>
                    <button className="right_arrow">Next</button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </section>
      )} */}

      {/* <section className="bloginner_sec3" data-aos="fade-up">
        <div className="horizontal_line"></div>
        <div className="wrapper">
          <div className="heading_arrow_flex2">
            <h2 className="moreblog_heading">More Blogs</h2>
            {width > 767 ? (
              <div className="navigations">
                <button className="left_arrow">Previous</button>
                <button className="right_arrow">Next</button>
              </div>
            ) : null}
          </div>

          <div className="moreblogs_wrapper">
            <div className="swiper-container moreblogs_swiper_container">
              <ul className="swiper-wrapper moreblogs_swiper_wrapper">
                {moreblogsList}
              </ul>
            </div>
            {width < 767 ? (
              <div className="arrows_wrapper">
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section> */}
      {/* <FsLightbox toggler={toggler} sources={[vidLink]} /> */}
    </>
  );
};

export default BlogInner;
